import Alert from 'react-bootstrap/Alert'

import { useCard } from '@/utils/fetcher'
import { formatUrl } from '@/utils/helpers'

type Props = {
  cardName: string
}

const PluginError = ({ cardName }: Props) => {
  const name = formatUrl(cardName.split('|')[0])
  const { data, error } = useCard({ card: { name }, name: cardName })

  if (error || data?.typo) {
    return (
      <>
        {data?.typo && <Alert variant='warning'>[edhrec-plugin:typo] {cardName}</Alert>}
        {error && <Alert variant='danger'>[edhrec-plugin:error] {cardName}</Alert>}
      </>
    )
  }
}

export default PluginError
